import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["parentSelect", "parentCard"];

  connect() {
    this.initParentSelect();
    this.element.addEventListener("ajax:success", () => {
      const callback = () => {
        window.Turbolinks.visit(location);
      };

      $(this.element).trigger("close.modal", [callback]);
    });
  }

  initParentSelect() {
    const select = $(this.parentSelectTarget);

    select.select2({
      width: "100%",
      theme: "novem",
      language: {
        noResults: function () {
          return window.i18n.t("view.admin.partner_change_parent_controller.select_partner_no_valid");
        }
      }
    });
    select.on("select2:open", function() {
      $("input.select2-search__field").attr("placeholder", window.i18n.t("view.admin.partner_change_parent_controller.find_partner"));
    });
    select.on("select2:select", (e) => {
      const selectedPartnerId = e.params.data.id;
      this.loadParentCard(selectedPartnerId);

      const contractPartnerSelect = document.getElementById("contract_partner_id");
      if (contractPartnerSelect) contractPartnerSelect.value = selectedPartnerId;
    });
  }

  async loadParentCard(id) {
    if (id) {
      this.parentCardTarget.innerHTML = await fetch(`/partners/${id}/card`)
        .then(response => response.text())
        .then(html => { return html; });
    } else {
      this.parentCardTarget.innerHTML = "";
    }
  }
}
